import { useGenesisAPI } from "../../Hooks/GenesisApiHook";
import * as GenesisTypes from "../../types/genesisTypes";

export function useV2SiteStatus(siteId: string) {
  const { sites } = useGenesisAPI();
  const query = sites.status.useQuery(
    { site_mongo_id: siteId },
    {
      enabled: !!siteId,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  );

  return {
    data: query.data ?? ([] as GenesisTypes.GenesisSiteStatusJson[]),
    loading: query.isLoading || query.isFetching,
    error: query.error ? query.error.message : null,
    fetchSiteStatus: query.refetch,
  };
}
